module.exports = __webpack_public_path__ + "media/images/category/dummy/outer05-8c4130e87e66805f6ec6b5730a2e2db5.jpg";